import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "SupplierCompanyListPage" */
	'pages/supplier/SupplierCompany/SupplierCompanyListPage'));

export default [{ component, exact: true, path: '/supplier_companies' }];